/* eslint-disable tailwindcss/no-custom-classname */
import { useRouter } from 'next/router'
import { SILVER_MAX_BOOK_COUNT } from '@/utils/constant'

export const ReadMoreSilverOverLimit: React.FC = () => {
  const router = useRouter()

  return (
    <>
      <img
        src={`${process.env.IMG_SERVER}/common/readmore.png`}
        alt="もっと見る"
        className="mt-[-160px] w-full h-[160px] align-middle border-none"
      />
      <div className="m-4 sm:m-1">
        <div className="p-5 border border-[#fd8637] border-solid">
          <div className="text-[17px]">
            <div>
              <img
                src={`${process.env.IMG_SERVER}/common/logo.png`}
                alt="flierロゴ"
                className="align-middle border-none"
              />
              この要約を読みたいですか？
            </div>
            <div className="pt-5 text-justify">
              シルバープランでは
              <span className="text-[17px] text-justify text-[#fd8637]">
                毎月{SILVER_MAX_BOOK_COUNT}冊まで
              </span>
              閲覧可能です。
              <br />
              既に今月は
              <span className="text-[17px] text-justify text-[#fd8637]">
                上限の{SILVER_MAX_BOOK_COUNT}冊
              </span>
              を閲覧しています。以下のいずれかをご選択ください。
            </div>
            <div className="pt-5 text-center">
              <button
                className="inline-block relative before:absolute before:top-[calc(50%-3px)] before:left-[10px] py-0 px-[30px] mb-0 before:w-[7px] h-[50px] before:h-[7px] text-sm font-normal leading-snug text-center text-white align-middle whitespace-nowrap bg-[#92949b] hover:bg-[#5e616e] rounded-[4px] border-b-2 before:border-b-2 before:border-l-2 border-[#5e616e] before:border-white border-solid before:border-solid before:rotate-45 cursor-pointer before:content-['']"
                onClick={() => router.push('/')}
              >
                トップページへ
              </button>
              <button
                className="inline-block relative after:absolute after:top-[calc(50%-3px)] after:right-[10px] py-0 px-[30px] mb-0 ml-[5px] after:w-[7px] h-[50px] after:h-[7px] text-sm font-normal leading-snug text-center text-white align-middle whitespace-nowrap bg-fl-orange hover:bg-[#bf6224] rounded-[4px] after:border-r-2 border-b-2 after:border-b-2 border-[#0d1733] after:border-white border-b-[#bf6224] border-solid after:border-solid after:rotate-[-45deg] cursor-pointer after:content-['']"
                onClick={() => router.push('/user/upgrade?from=summary')}
              >
                アップグレード
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
